// extracted by mini-css-extract-plugin
module.exports = {"zone":"DropZone_zone__3WJUx","last":"DropZone_last__3rHWW","hover":"DropZone_hover__1uB94"};